import { useQuery } from "@tanstack/react-query";
import apiClient from "@/services/api/client";
import { API_ENDPOINTS } from "@/services/api/endpoints";
import { QUERY_KEYS } from "@/services/api/queryKeys";
import type { MasterLlmModel } from "@/types";

export const useMasterLlmModels = () => {
  const query = useQuery({
    queryKey: QUERY_KEYS.LLM_MODELS.LIST(),
    queryFn: async () => {
      const response = await apiClient.get<MasterLlmModel[]>(
        API_ENDPOINTS.SYSTEM.LLM_MODELS.BASE
      );
      const data = response.data;
      return Array.isArray(data) ? data : [];
    },
    staleTime: 5 * 60 * 1000,
  });

  const allModels = query.data ?? [];
  const chatModels = allModels.filter((m) => m.mode === "chat");
  const embeddingModels = allModels.filter((m) => m.mode === "embedding");
  const visionModels = chatModels.filter((m) => m.provider.toLowerCase() === "openai");

  return {
    masterModels: allModels,
    chatModels,
    embeddingModels,
    visionModels,
    isLoading: query.isLoading,
    error: query.error,
  };
};
